import { parse } from "graphql";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { createFormattedTitleFromArray } from "@limitless/common/utils";
const TYPE_MAP = {
  tags: "[String]",
  msgClassification: "MsgClassificationInput",
  default: "String"
};
export const getEncodingFieldsAndType = payload => {
  const fields = [];
  const params = [];
  Object.keys(payload).map(key => {
    const type = TYPE_MAP[key] || TYPE_MAP["default"];
    fields.push(`$${key}: ${type}`);
    params.push(`${key}: $${key}`);
  });
  return {
    fields,
    params
  };
};

/**
 * Creates the GraphQL mutation dynamically based on what has been configured for the group.
 *
 * @param {object} payload
 * @param {object} message
 */
export const getEncodingPayload = (payload, message) => {
  const log = pilog.getLogger("MessageClasificationMutations getEncodingPayload");
  log.debug(payload);
  const {
    fields,
    params
  } = getEncodingFieldsAndType(payload);
  const mutation = `mutation encodeMessage($messageId: String!, ${createFormattedTitleFromArray(fields)}) {
                        encodeMessage(messageId: $messageId, ${createFormattedTitleFromArray(params)}) {
                            messageId
                            dialogueNoteUIControl
                            expertPrefUIControl
                        }
                    }
                `;
  log.debug(mutation);
  return {
    mutation: parse(mutation),
    variables: {
      messageId: message.messageId,
      ...payload
    }
  };
};